import { createSelector } from '@ngrx/store';

import type { CampaignAnalyticsConfig } from '@core/integrations-legacy';
import { groupByKey } from '@core/utils-legacy';
import type { JobBoard, JobBoardSettingsItem } from '@recruitee/job-boards-types';

import { CampaignAnalyticsConfigSelectors } from '../campaign-analytics-config/campaign-analytics-config.store';
import { jobBoardRequiresCredentials } from '../helpers';
import { JobBoardSelectors } from '../job-board/job-board.store';

const combineJobBoardsWithCampaignAnalyticsConfigs = (
  jobBoards: JobBoard[] | null,
  campaignAnalyticsConfigs: CampaignAnalyticsConfig[] | null,
): JobBoardSettingsItem[] | null => {
  if (!jobBoards || !campaignAnalyticsConfigs) return null;

  const jobBoardItems: JobBoardSettingsItem[] = jobBoards.map(jobBoard => ({
    ...jobBoard,
    jobBoard,
  }));

  const campaignAnalyticsItems: JobBoardSettingsItem[] = campaignAnalyticsConfigs.map(
    campaignAnalyticsConfig => ({
      ...campaignAnalyticsConfig,
      website: campaignAnalyticsConfig.url,
      campaignAnalyticsConfig,
    }),
  );

  return Object.values(groupByKey(campaignAnalyticsItems.concat(jobBoardItems), 'codename'))
    .map(items => items.reduce((acc, item) => ({ ...acc, ...item })))
    .filter(jobBoardSettingsItemConfigurable);
};

const jobBoardSettingsItemConfigurable = (item: JobBoardSettingsItem): boolean =>
  !!(item.campaignAnalyticsConfig || (item.jobBoard && jobBoardRequiresCredentials(item.jobBoard)));

const selectors = {
  data: createSelector(
    JobBoardSelectors.entities(),
    CampaignAnalyticsConfigSelectors.active,
    combineJobBoardsWithCampaignAnalyticsConfigs,
  ),
};

export { selectors as JobBoardSettingsItemSelectors };
